/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import React from "react";

interface PublicRouteProps {
  component: React.ComponentType;
  layout: React.ComponentType<any>;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  return (
    <Layout {...rest}>
      <Component />
    </Layout>
  );
};

export default PublicRoute;
